module.exports = __webpack_public_path__ + "img/feature-2.201a5aa7.png";